<template>
  <svg x="0px" y="0px" viewBox="0 0 64 64" width="64" height="64">
    <path
      d="M45.7,54.9H9.3c0,5.1,4.1,9.1,9.1,9.1h27.2c5,0,9.1-4.1,9.1-9.1V17.3c0-0.2-0.1-0.3-0.3-0.3H46
				c-0.2,0-0.3,0.1-0.3,0.3V54.9z M45.7,0c5,0,9.1,4.1,9.1,9.2H18.4v37.6c0,0.2-0.2,0.3-0.3,0.3H9.6c-0.2,0-0.3-0.2-0.3-0.3V9.2
				c0-5.1,4.1-9.2,9.1-9.2L45.7,0L45.7,0"
    />
  </svg>
</template>
